import { createColumnHelper } from '@tanstack/react-table';

import { SKU } from 'types/sku';

const col = createColumnHelper<SKU>();

export const buildSkuItemsColumns = () => [
  // Narrower than the rest, to make room for Manufacturer (ClickUp 86bceudwp).
  col.accessor((sku) => sku.prefix || '-', {
    id: 'prefix',
    header: 'SKU Prefix',
    minSize: 80,
    size: 110,
  }),
  col.accessor((sku) => sku?.name || '-', {
    id: 'name',
    header: 'SKU Name',
    minSize: 150,
  }),
  col.accessor((sku) => sku?.manufacturerDetails?.name || '-', {
    id: 'manufacturer',
    header: 'Manufacturer',
    minSize: 140,
  }),
  col.accessor((sku) => sku?.itemType || '-', {
    id: 'itemType',
    header: 'Type',
    minSize: 100,
  }),
  col.accessor((sku) => sku?.size || '-', {
    id: 'size',
    header: 'Size (Oz)',
    minSize: 80,
  }),
  col.accessor((sku) => sku?.primaryColor || '-', {
    id: 'primaryColor',
    header: 'Primary Color',
    minSize: 100,
  }),
  col.accessor((sku) => sku?.material || '-', {
    id: 'material',
    header: 'Material',
    minSize: 100,
  }),
];
